export default __webpack_public_path__ + "static/media/tiffany.91d51454.png";